import React from 'react';
import { Box } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';
import { useIsExperimentActivated } from '@99designs/experiments';
import GlobalNav from '@99designs/site-navigation/components/GlobalNav/GlobalNav';
import Drawers from '@99designs/site-navigation/components/GlobalNavDrawers/GlobalNavDrawers';
import SiteHeader from '@99designs/site-navigation/components/SiteHeader/SiteHeader';
import SiteFooterStyleOverride from '../SiteFooter';
import type { Role } from '@99designs/site-navigation/consts';
import type { Site } from '@99designs/site-navigation/lib/Site';

interface Props {
    role: Role;
    site: Site;
    maxWidth?: 'widescreen' | 'desktop';
    children: React.ReactNode;
}

export default function DefaultPageLayout({
    role,
    children,
    site,
    maxWidth = 'widescreen',
}: Props) {
    const isSandbox = useIsExperimentActivated('marketingEnv', 'sandbox');

    return (
        <div className={`app max--${maxWidth} transparent-site-header`}>
            {isSandbox && (
                <Box
                    display="flex"
                    justifyContent="center"
                    paddingY="1bu"
                    color={colors.white}
                    background={colors.heritage}
                >
                    SANDBOX
                </Box>
            )}
            <GlobalNav>
                {({ toggleDrawer, drawerState }) => (
                    <>
                        <SiteHeader
                            role={role}
                            site={site}
                            variations={['gradient']}
                            onLeftDrawerTriggerClick={toggleDrawer('left', true)}
                            onRightDrawerTriggerClick={toggleDrawer('right', true)}
                        />

                        {children}
                        <Drawers
                            toggleDrawer={toggleDrawer}
                            role={role}
                            site={site}
                            drawerState={drawerState}
                        />
                        <SiteFooterStyleOverride site={site} />
                    </>
                )}
            </GlobalNav>
        </div>
    );
}
